module.exports = [{"id":"Kansaco","modalTarget":["opcionModal1"],"imgProducto":["/imga/productos_quimicos/productos_quimicos.jpg"],"title":["#Nombre"],"materialesDisponibles":[],"pasos":[]},{"id":"WD40","imgProducto":["/imga/productos_quimicos/productos_quimicos.jpg"],"modalTarget":["opcionModal2"],"title":["#Nombre"],"materialesDisponibles":[],"pasos":[]},{"id":"Siloc","imgProducto":["/imga/productos_quimicos/productos_quimicos.jpg"],"modalTarget":["opcionModal3"],"title":["#Nombre"],"materialesDisponibles":[],"pasos":[]}]


//////////////////
// WEBPACK FOOTER
// ./src/components/productos_quimicos.json
// module id = 97
// module chunks = 0